import { Injectable } from "@angular/core";
import { RouteId } from "../enums/env/routes-id-enum";
import { RouteEnv } from "../interfaces/env/RouteEnv";
import { MainRoute } from "../models/MainRoute";
import { RightService } from "./right.service";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class RoutingService {

  constructor(private rightService: RightService) {
  }

  public static getRoute(routeId: RouteId): MainRoute {
    return new MainRoute(RoutingService.searchRoute(environment.core.routes, routeId) as RouteEnv, routeId);
  }

  public getRoutesLeftMenu(): MainRoute[] {
    const listRoute: MainRoute[] = [];
    environment.core.routes.forEach((r: any) => {
      switch(r.id) {
        case RouteId.DASHBOARD:
            const canAccessDashboard: boolean = this.rightService.canAccessSiteOperationManagement();
            if(r.enabled && canAccessDashboard) {
              listRoute.push(r);
            }
        break;

        case RouteId.DAF_MANAGEMENT:
            const canAccessDaf: boolean = this.rightService.canAccessToDaf();
            if(r.enabled && canAccessDaf) {
              listRoute.push(r);
            }
        break;

        case RouteId.REPORTING:
          const canAccessReporting: boolean = this.rightService.canAccessToReporting();
          if(r.enabled && canAccessReporting) {
            listRoute.push(r);
          }
          break;

        case RouteId.ADMINISTRATION:
          const canAccessAdministration: boolean = this.rightService.canAccessAdministration();
          if(r.enabled && canAccessAdministration) {
            listRoute.push(r);
          }
          break;
      }
    });

    return listRoute;
  }

  public static getPathRoute(routeId: RouteId): string {
    return RoutingService.getRoute(routeId).path;
  }

  private static searchRoute(routesEnv: RouteEnv[], routeId: RouteId): RouteEnv | null{
    for (const route of routesEnv) {
      if (route.id === routeId) {
        return route;
      }

      if (route.tabs) {
        const found = this.searchRoute(route.tabs, routeId);
        if (found) {
          return found;
        }
      }

      if (route.subRoutes) {
        const found = this.searchRoute(route.subRoutes, routeId);
        if (found) {
          return found;
        }
      }
    }

    return null;
  }

  public static getStationRoute(): MainRoute {
    return RoutingService.getRoute(RouteId.STATIONS);
  }
}
